import { Injectable } from '@angular/core';
import { StaffRole } from '@models/staff-role/staff-role';
import { HttpService } from '@services/http.service';

import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class StaffRolesService extends HttpService {
    private staffRolesSubject = new BehaviorSubject<StaffRole[]>([]);
    private isLoadingDataSubject = new BehaviorSubject<boolean>(true);
    private dataStore: { staffRoles: StaffRole[] } = { staffRoles: [] };

    get staffRoles(): Observable<StaffRole[]> {
        return this.staffRolesSubject.asObservable();
    }

    get loadingData(): Observable<boolean> {
        return this.isLoadingDataSubject.asObservable();
    }

    list(): void {
        this.loading(true);
        this.listServices().subscribe(
            () => {
                this.next([ ...this.dataStore.staffRoles ]);
                this.loading(false);
            }
        );
    }

    search(idService: string): void {
        this.get(`stripe/member/historical/payments/${idService}`, { app: 'member', version: 1 }).subscribe(
            data => {
                const index: number = this.dataStore.staffRoles.findIndex(c => c.id === idService);
                if (index > -1) {
                    this.dataStore.staffRoles[index] = new StaffRole().build(data);
                } else {
                    this.dataStore.staffRoles.push(new StaffRole().build(data));
                }

                this.next([ ...this.dataStore.staffRoles ]);
            }
        );
    }

    private listServices(): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                this.get('customer/categories', { app: 'member', version: 3 }).subscribe(
                    data => {
                        this.dataStore.staffRoles = [];
                        data.forEach((payment: any) => {
                            this.dataStore.staffRoles.push(new StaffRole().build(payment));
                        });

                        observable.next(true);
                    }, () => observable.next(false)
                );
            }
        );
    }

    private next(data: StaffRole[]): void {
        this.staffRolesSubject.next(data);
    }

    private loading(value: boolean): void {
        this.isLoadingDataSubject.next(value);
    }
}
